module.exports = __webpack_public_path__ + "img/lqsxtou_3.dbbc48e7.svg";